module.exports = __webpack_public_path__ + "img/proyecto_especial.491c9ff0.svg";